import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { EditProfileRequest } from '../api/myaccount/editprofile/editprofilerequest';
import { EditProfileResponse, EditProfileResponseDtoImpl } from '../api/myaccount/editprofile/editprofileresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class EditProfileAPIProcessorImpl extends SixdeeCRBTAPIProcessor<EditProfileRequest, EditProfileResponse>
{
    execute(request: EditProfileRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new EditProfileResponseDtoImpl(APIFeatures.EDIT_PROFILE, "Edit Profile Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new EditProfileResponseDtoImpl(APIFeatures.EDIT_PROFILE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

            this.getAPIFailure(new EditProfileResponseDtoImpl(APIFeatures.EDIT_PROFILE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/editprofileapiprocessor.tsx